import { render, staticRenderFns } from "./InboxMenu.vue?vue&type=template&id=02426e5f&"
import script from "./InboxMenu.vue?vue&type=script&lang=js&"
export * from "./InboxMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports